import React, { Component,useContext  } from "react"
import { apiEndpoint } from "helpers/url_helper";

import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
} from "reactstrap"

import InnerImageZoom from "react-inner-image-zoom";
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';
//import { ActiveImageContext } from './ViolationImageContext';


class Slidewithindicator extends Component {


  constructor(props) {
    //const {violationImageIndex, setViolationImageIndex} = useContext(ActiveImageContext);
    super(props)
    var violationImgArr;
    var Imageitems=[];
    //console.log("Default Image Index"+props.ImageIndex(2));
    if(props.ImagePath!=null){
      if(props.ImagePath.ViolationImgBase64Img!=null){
        violationImgArr=props.ImagePath.ViolationImgBase64Img;
        if(violationImgArr.length>0){
          for(var i=0;i< violationImgArr.length;i++){
      Imageitems.push({ src: `data:image/png;base64,${violationImgArr[i]}`,
      altText: "Slide "+parseInt( i+1)+"",
      caption: "Slide "+ parseInt( i+1)+"",
       })
      }
       }
      }
    this.state = { 
      activeIndex: 0 ,
      Imageitems:Imageitems
    }
    console.log(this.state.Imageitems)
    }

    
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
    this.goToIndex = this.goToIndex.bind(this)
    this.onExiting = this.onExiting.bind(this)
    this.onExited = this.onExited.bind(this)
    
  }
 


  onExiting() {
    this.animating = true
  }

  onExited() {
    this.animating = false
  }

  next() {
    if (this.animating) return
    const nextIndex =
      this.state.activeIndex === this.state.Imageitems.length - 1
        ? 0
        : this.state.activeIndex + 1
    this.setState({ activeIndex: nextIndex })
    console.log(this.state.activeIndex)

    let ImageIndextemp = nextIndex;
    console.log(this.props)
    this.props.ImageIndex(ImageIndextemp);
   // console.log("Default Image Index"+props.ImageIndex(2));
    console.log("Next ImageIndex -------->", ImageIndextemp);
   // console.log("Context ImageIndex -------->", violationImageIndex);
  }

  previous() {
    if (this.animating) return
    const nextIndex =
      this.state.activeIndex === 0
        ? this.state.Imageitems.length - 1
        : this.state.activeIndex - 1
    this.setState({ activeIndex: nextIndex })
    
    let ImageIndextemp = nextIndex;
    console.log(this.props)
    this.props.ImageIndex(ImageIndextemp);

  }

  goToIndex(newIndex) {
    if (this.animating) return
    this.setState({ activeIndex: newIndex })
  }

  render() {
    let ImageActiveIndex = this.context;
    const { activeIndex } = this.state.activeIndex
    const  Imageitemss = this.state.Imageitems
    const slides = Imageitemss.map(item => {
      return (
       

        <CarouselItem
          onExiting={this.onExiting}
          onExited={this.onExited}
          key={item.src}
        >
          {/* <img
            src={item.src} width="100%"
            className="d-block img-fluid"
            alt={item.altText}
          /> */}
          <InnerImageZoom 
          width="100%"
            src={item.src}
            zoomSrc={item.src}
            moveType="drag"
            zoomScale="1"
            hideCloseButton="true"
            hideHint="true"
          />
        </CarouselItem>
      )
    })

    return (
      <React.Fragment>
        <Carousel
        interval={0}
          activeIndex={this.state.activeIndex}
          next={this.next}
          previous={this.previous}
          keyboard={false} 
        >
          <CarouselIndicators
            items={this.state.Imageitems} 
            activeIndex={this.state.activeIndex}
            onClickHandler={this.goToIndex}
          />
          {slides}
                   
          {this.state.Imageitems.length>1 &&  
         
          <CarouselControl
            direction="prev"
            directionText="Previous"
            onClickHandler={this.previous}
          />
  }
          {this.state.Imageitems.length>1 &&  
         
          <CarouselControl
            direction="next"
            directionText="Next"
            onClickHandler={this.next}
          />
  }
        </Carousel>
      </React.Fragment>
    )
  }
}

export default Slidewithindicator
